import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CONTACT_US: "Kontakt oss",
      CHAT_WITH_US: "Chat med oss",
      FAQ_TITLE: "Ofte stilte spørsmål og svar",
      FAQ_SUBTEXT:
        "De vanligste spørsmålene og svarene er samlet her. Les gjennom dem før du kontakter kundeservice.",
      SEE_FAQ: "Se alle spørsmål og svar",
      SEND_MAIL: "Skriv til oss",
      SEND_MAIL_TO: "Send oss en e-post på",
      CALL_US: "Ring oss",
      CONTACT_CS_FOR_AN_OVERVIEW_UNPAID_ORDERS:
        "Ta kontakt med kundeservice for oversikt over dine ubetalte fakturaer.",
      SEND_US_A_CLAIM: "Send oss en reklamasjon",
      TELL_US_WHAT_WENT_WRONG:
        "Fortell Kundeservice om noe var galt med leveringen din.",
      REPORT_PROBLEMS_OR_MISSING_ITEMS: "Rapporter feil/mangler",
    },
    se: {
      CONTACT_US: "Kontakta oss",
      CHAT_WITH_US: "Chatta med oss",
      FAQ_TITLE: "Vanliga frågor och svar",
      FAQ_SUBTEXT:
        "De vanligaste frågorna och svaren finns samlade här, vänligen läs igenom innan du kontaktar support.",
      SEE_FAQ: "Se alla frågor och svar",
      SEND_MAIL: "Skriv til oss",
      SEND_MAIL_TO: "Skicka ett mail till",
      CALL_US: "Ring oss",
      CONTACT_CS_FOR_AN_OVERVIEW_UNPAID_ORDERS:
        "Kontakta kundservice för att få en översikt över dina obetalda fakturor.",
      SEND_US_A_CLAIM: "Skapa reklamation",
      TELL_US_WHAT_WENT_WRONG:
        "Kontakta kundservice om något var fel med din leverans.",
      REPORT_PROBLEMS_OR_MISSING_ITEMS: "Rapportera fel/saknad vara",
    },
    dk: {
      CONTACT_US: "Kontakt os",
      CHAT_WITH_US: "Chat med os",
      FAQ_TITLE: "Oftest stillede spørgsmål",
      FAQ_SUBTEXT:
        "Vi har samlet de oftest stillede spørgsmål ét sted. Se om dine svar er her!",
      SEE_FAQ: "Se oftest stillede spørgsmål",
      SEND_MAIL: "Send mail",
      SEND_MAIL_TO: "Send en mail til",
      CALL_US: "Per telefon",
      CONTACT_CS_FOR_AN_OVERVIEW_UNPAID_ORDERS:
        "Kontakt kundeservice for at få en oversigt over dine ubetalte fakturaer.",
      SEND_US_A_CLAIM: "Opret reklamation",
      TELL_US_WHAT_WENT_WRONG:
        "Kontakt kundeservice, hvis der var noget galt med din levering.",
      REPORT_PROBLEMS_OR_MISSING_ITEMS: "Rapporter fejl/manglende varer",
    },
  } as const
)[language];
